export enum SignUpProductEnum {
  health = "health",
  liability = "liability",
}
